import React, { useEffect, useState } from 'react';
import CardResultado from '../src/components/CardResultado'; 
import { IEstadoCidades } from '../src/interface/index'
import { Form, Button, InputGroup, Row } from 'react-bootstrap';
import api from './services/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/styles/App.css';

function App() {
  const [ cidade, setCidade ] = useState("");
  const [ estados, setEstados ] = useState<IEstadoCidades[]>([]);
  const [ minLength, setMinLength] = useState(false);

  const handleCityChange = (e:any) => {
    setCidade(e.target.value);
  };
 
  const handleSearch = () => {
    if(cidade) setMinLength(true);   
  };

  useEffect(() => {
    const fetchCidades = async () => {
      try {
        const response = await api.get(`/?cidade=${cidade}`);
        setEstados(response.data.estados);             
      } catch (error) {
        console.log("Error:", error);
      }finally{
        setMinLength(false);
      }
    };

    if(cidade.length > 3){
      fetchCidades();
    }else if(minLength === false && cidade.length === 0){
      setEstados([]);
    }else if(minLength === true){
      fetchCidades();
    }
  },[cidade, minLength]);

  return (
    <div className="App container mt-5">
      <h2 className="mb-4">Descubra se está homologada também em sua cidade:</h2>
      <Form>
        <InputGroup className="mb-3">
          <Form.Control
            placeholder="Buscar da cidade por nome"
            value={cidade}
            onChange={handleCityChange}
          />
          <Button variant="primary" onClick={handleSearch}>Buscar</Button>
        </InputGroup>
      </Form>
      {estados.map((itemUF, index) => (
        <Row className='mt-5 justify-content-center' key={index}>
          <h4>Estado: {itemUF.uf}</h4>
          {itemUF.cidades.map((itemCidade, index) =>
            <CardResultado selecaoCidade={itemCidade} index={index}/>
          )}
        </Row>
      ))}
      {(cidade.length < 1 || estados.length < 1) && (
        <div className="nenhum-registro-encontrado">
            <strong>Nenhum registro encontrado!</strong>
            <br/> Certifique-se de que o nome esteja completo e correto.
        </div>
      )}
    </div>
  );
}

export default App;